import { clientTypes } from "../../type/clientTypes";

const initialState = {
  searchLoading: false,
  isLoading: false,
  dataDetails: [],
  msg: "",
};

export const getUserDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case clientTypes.GET_USER_DETAIL_DATA_PENDING:
      return {
        ...state,
        searchLoading: action.isLoading,
        isLoading: true,
        msg: "",
      };
    case clientTypes.GET_USER_DETAIL_DATA_SUCCESS:
      return {
        ...state,
        searchLoading: action.isLoading,
        dataDetails: action.payload,
        isLoading: false,
        msg: action.msg,
      };
    case clientTypes.GET_USER_DETAIL_DATA_FAILED:
      return {
        ...state,
        searchLoading: action.isLoading,
        dataDetails: action.payload,
        msg: action.msg,
        isLoading: false,
      };
    default:
      return state;
  }
};
